import { Button, ModalDialog, Typography } from "@ezmid/components-library";
import { useTranslation } from "react-i18next";

type Props = {
  isModalOpen: boolean;
  onModalClose: () => void;
  onConfirmDelete: () => void;
  itemName: string;
  isDeleting?: boolean;
  titleKey: string;
  confirmMessageKey: string;
};

export function DeleteConfirmationModal({
  isModalOpen,
  onModalClose,
  onConfirmDelete,
  itemName,
  isDeleting = false,
  titleKey,
  confirmMessageKey,
}: Props) {
  const { t } = useTranslation();

  return (
    <ModalDialog
      id="delete-confirmation-modal"
      isOpen={isModalOpen}
      title={t(titleKey)}
      onRequestClose={onModalClose}
      footerControls={
        <div className="flex gap-2">
          <Button onClick={onModalClose} disabled={isDeleting}>
            {t("button.cancel")}
          </Button>
          <Button
            variant="danger"
            onClick={onConfirmDelete}
            disabled={isDeleting}
          >
            {t("button.delete")}
          </Button>
        </div>
      }
    >
      <div className="p-4">
        <Typography variant="body1">{t(confirmMessageKey)}</Typography>
        <Typography variant="body1" className="mt-4 font-semibold">
          {itemName}
        </Typography>
      </div>
    </ModalDialog>
  );
}
